import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
//@ts-ignore
import { EVALUABLE_CLESSON_MODES } from '@yandex-int/k-common/constants';
import { CLessonInCourse, Course, LESSON_STATUS, LessonSubscription } from '@yandex-int/k-common/typings';
import get from 'lodash/get';
import { showIntlMessageNotification as showIntlMessageNotificationAction, SimpleCallback } from 'platform-components';
import { NOTIFICATION_THEMES } from 'platform-components/src/components/constants';
import { getIsContentManager, getIsParent, getIsTeacher } from 'platform-components/src/components/user/selectors';
import {
    InjectedProps as WithRouterPathHOC,
    InjectedSocketIoProps,
    withRouterPath,
    withSocketIO,
} from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React, { Ref } from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';

import copyLessonModalActions from 'common.components/copy-lesson-modal/actions';
import lessonActions from 'common.components/lesson/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import withTime, { InjectedProps as WithNowProps } from 'common.components/timer/withTime';
import { NOTIFICATION_CLOSE_DELAY } from 'common.components/user/class.constants';
import {
    getCurrentTeamEnteringCode,
    getIsStudentRegistrationLinkAvailableInTeam,
} from 'common.components/user/selectors';
import { ClessonProgressData } from 'store/clesson-results/utils';
import { getCourseByClassAndId } from 'store/courses/selectors';
import { prepLessonsActions } from 'store/prep-lessons/actions';
import { getLessonPermissions, LessonPermissions } from 'utils/lesson';
import { getTeamIdFromPath } from 'utils/path';

import { CalendarLessonCard } from '../../calendar-lesson-card/calendar-lesson-card';
import { isLessonAssigned, isLessonCompleted, isLessonInProgress } from '../../lesson/utils';
import { ListLessonItem } from '../../list-lesson-item/list-lesson-item';
import * as actions from '../actions';
import { getActiveSubscriptionSlug } from '../selectors';

interface StoreProps {
    clessonId: number | null;
    isContentManager: boolean;
    isParent: boolean;
    isTeacher: boolean;
    shouldDisableClesson: boolean;
    course?: Course;
    lessonPermissions: LessonPermissions;
    activeSubscriptionSlug: string | null;
    isInStudentLinkExperiment: boolean;
    currentTeamEnteringCode: string | null;
    clessonProgress?: ClessonProgressData;
    clessonProgressLoadingStatus: LOADING_STATUSES;
    forceCompleteLessonSuccess?: SimpleCallback;
}

interface DispatchProps {
    clearEditor: typeof lessonActions.clearEditor;
    deleteCLesson: typeof lessonActions.deleteCLesson;
    getClessonWithResultsRequest: typeof lessonActions.getClessonWithResultsRequest;
    getFullClessonRequest: typeof lessonActions.getFullClessonRequest;
    showIntlMessageNotification: typeof showIntlMessageNotificationAction;
    copyLesson: typeof copyLessonModalActions.copyCLesson;
    forceCompleteLesson: typeof actions.forceCompleteLesson;
    showLessonDeletedToast: typeof lessonActions.showLessonDeletedToast;
    clearPrepLessonsDetails: typeof prepLessonsActions.clearPrepLessonsDetails;
}

interface HOCProps extends WithRouterPathHOC, WrappedComponentProps, InjectedSocketIoProps, WithNowProps {}

interface OwnProps {
    checkShouldDisableLesson?: (cLessonId: number) => boolean;
    courseId: number;
    course?: Course;
    clesson: CLessonInCourse;
    onEnterViewport?: SimpleCallback;
    onLessonClick: (clessonId: number | null) => void;
    onSetRef?: (ref: HTMLDivElement | null) => void;
    onSettingsClick?: SimpleCallback;
    shouldShowDuration?: boolean;
    shouldShowEvaluationDate?: boolean;
    shouldShowLikes: boolean;
    shouldShowSettings: boolean;
    subscriptions?: Array<LessonSubscription>;
    likesCount: number | undefined;
    onShowLikesPopup: (clessonId: number, likeRef: Ref<HTMLElement>) => void;
    onHideLikesPopup: () => void;
    isListView?: boolean;
    clessonProgress?: ClessonProgressData;
    clessonProgressLoadingStatus: LOADING_STATUSES;
    forceCompleteLessonSuccess?: SimpleCallback;
}

interface Props extends StoreProps, DispatchProps, HOCProps, OwnProps {}

export class LessonItemView extends React.Component<Props> {
    static contextTypes = {
        basePath: PropTypes.string.isRequired,
        prefix: PropTypes.string.isRequired,
        staticUrls: PropTypes.object.isRequired,
    };

    state = {
        shouldShowCopyModal: false,
    };
    context!: React.ContextType<
        React.Context<{
            staticUrls: Record<string, string>;
            prefix: string;
            basePath: string;
            websocketDomain: string;
        }>
    >;

    setRef = (ref: HTMLDivElement | null) => {
        const { onSetRef } = this.props;

        if (onSetRef) {
            onSetRef(ref);
        }
    };

    handleLessonDelete = () => {
        const {
            deleteCLesson,
            clesson: { id: cLessonId, date_assignment: dateAssignment },
            showLessonDeletedToast,
            activeSubscriptionSlug,
            clearPrepLessonsDetails,
        } = this.props;
        const isDraft = !dateAssignment;

        deleteCLesson({
            cLessonId,
            onSuccess: () => {
                showLessonDeletedToast({ cLessonId, isDraft });
                clearPrepLessonsDetails();
            },
            isDraft,
        });

        ym('reachGoal', 'button_delete_lesson', {
            clessonId: cLessonId,
            subscription_slug: activeSubscriptionSlug,
        });
    };

    handleCopyLesson = () => {
        const {
            clesson: {
                id,
                lesson: { name },
            },
            copyLesson,
            intl,
            history,
        } = this.props;

        copyLesson({
            sourceId: id,
            newName: intl.formatMessage({ id: 'lesson.copyNewName' }, { name }),
            intl,
            //@ts-ignore почему-то не сходятся тайпинги
            history,
        });
    };

    // TODO: вынести всю внутреннюю логику по месту исопльзования
    // eslint-disable-next-line complexity
    handleLessonClick = () => {
        const {
            clessonId,
            course,
            clearEditor,
            clesson,
            getClessonWithResultsRequest,
            getFullClessonRequest,
            isParent,
            isTeacher,
            getRouterPath,
            history,
            onLessonClick,
        } = this.props;
        const { id: assignmentId, date_assignment: dateAssignment, status: lessonStatus } = clesson;
        const courseId = course?.id;
        const subject = course?.subject;
        const isDraft = !dateAssignment;
        const isCompleted = isLessonCompleted(lessonStatus);
        const isInProgress = isLessonInProgress(lessonStatus);
        const isAssigned = isLessonAssigned(lessonStatus);
        const shouldShowResult = isCompleted || isInProgress || lessonStatus === LESSON_STATUS.ASSIGNED;

        if (isParent && !isTeacher) {
            const {
                staticUrls: { parentChildCourseLesson },
            } = this.context;

            history.push(getRouterPath(parentChildCourseLesson, { subject, clessonId: assignmentId }));
            return;
        }

        if (clessonId !== assignmentId) {
            clearEditor();
        }

        if (courseId) {
            if (shouldShowResult) {
                getClessonWithResultsRequest({ courseId, clessonId: assignmentId });
            } else {
                getFullClessonRequest({
                    courseId,
                    clessonId: assignmentId,
                });
            }
        }

        if (onLessonClick) {
            onLessonClick(assignmentId);
        }

        const metrikaParams = {
            clessonId: assignmentId,
        };

        if (isDraft) {
            ym('reachGoal', 'teacher_lesson_open_draft', metrikaParams);
        }

        if (isInProgress || isCompleted) {
            ym('reachGoal', 'teacher_myclass_lesson_statistic_open', metrikaParams);
        }

        if (isAssigned) {
            ym('reachGoal', 'teacher_myclass_lesson_statistic_open', metrikaParams);
        }
    };

    handleCloseLesson = () => {
        const { forceCompleteLesson, forceCompleteLessonSuccess, clesson, io, course } = this.props;
        const courseId = course?.id;
        const { websocketDomain } = this.context;

        if (courseId) {
            forceCompleteLesson(clesson, courseId, io, websocketDomain, () => {
                if (forceCompleteLessonSuccess) {
                    forceCompleteLessonSuccess();
                }
            });
        }
    };

    getMetaTextId = () => {
        const {
            clesson: { lesson, mode },
        } = this.props;
        const methodologicalGoal = lesson.meta?.methodological_goal;

        if (methodologicalGoal) {
            return `lesson.lessonMeta.methodologicalGoals.${methodologicalGoal}`;
        } else if (mode) {
            return `lesson.lessonMeta.mode.${mode}`;
        }

        return null;
    };

    getLessonLinkUrl = (courseId: number | null, clessonId: number): string => {
        const {
            basePath,
            prefix,
            staticUrls: { kids, kidsAddByCode },
        } = this.context;
        const { getRouterPath, showIntlMessageNotification, isInStudentLinkExperiment, currentTeamEnteringCode } =
            this.props;

        if (courseId) {
            const path =
                isInStudentLinkExperiment && currentTeamEnteringCode
                    ? getRouterPath(kidsAddByCode, { code: currentTeamEnteringCode })
                    : getRouterPath(kids);

            return `${basePath}${prefix}${path}?course=${courseId}&lesson=${clessonId}`;
        }

        showIntlMessageNotification({
            messageId: 'lessonLink.cannotCopyLessonLink',
            theme: NOTIFICATION_THEMES.FAIL,
            closeDelay: NOTIFICATION_CLOSE_DELAY,
        });

        return '';
    };

    /* eslint-disable complexity */
    render() {
        const {
            course,
            clesson,
            isContentManager,
            shouldDisableClesson,
            shouldShowLikes,
            shouldShowSettings,
            lessonPermissions,
            onSettingsClick,
            activeSubscriptionSlug,
            likesCount,
            onShowLikesPopup,
            onHideLikesPopup,
            clessonProgress,
            clessonProgressLoadingStatus,
            isListView = true,
        } = this.props;

        const courseId = course?.id || null;
        const courseClosed = course?.closed;
        const { date_assignment: dateAssignment, id: clessonId, lesson } = clesson;

        const isDraft = !dateAssignment;
        // урок прошлых лет, который был выдан
        const isOldAssignedLesson = courseClosed && !isDraft;
        const accessible = isOldAssignedLesson || !courseClosed;
        const clickable = isContentManager || accessible;

        const cardsCount = lesson?.problems_count;

        const childLink = this.getLessonLinkUrl(courseId, clessonId);

        const commonProps = {
            cardsCount,
            childLink,
            clesson,
            courseId,
            clessonProgress,
            clessonProgressLoadingStatus,
            onCloseLesson: this.handleCloseLesson,
            onCopyLesson: this.handleCopyLesson,
            onLessonClick: this.handleLessonClick,
            onLessonDelete: this.handleLessonDelete,
            lessonPermissions,
            likesCount,
            onShowLikesPopup,
            onHideLikesPopup,
            shouldShowSettings,
            shouldDisableSettings: shouldDisableClesson || !clickable,
            shouldShowLikes,
            onSettingsClick,
            setRef: this.setRef,
        };

        if (isListView) {
            return (
                <ListLessonItem
                    {...commonProps}
                    activeSubscriptionSlug={activeSubscriptionSlug}
                    clickable={clickable}
                    shouldDisableClesson={shouldDisableClesson}
                />
            );
        }

        return <CalendarLessonCard {...commonProps} />;
    }
    /* eslint-enable complexity */
}

const mapStateToProps = (storeState: any, ownProps: OwnProps & HOCProps): StoreProps => {
    const {
        course: courseFromProps,
        courseId,
        clesson,
        now,
        subscriptions,
        checkShouldDisableLesson,
        clessonProgress,
        clessonProgressLoadingStatus,
        forceCompleteLessonSuccess,
    } = ownProps;

    const classId = getTeamIdFromPath();
    const course = courseFromProps || getCourseByClassAndId(storeState, { classId, courseId });
    const isEvaluable = EVALUABLE_CLESSON_MODES.includes(get(clesson, 'mode'));

    const lessonMeta = clesson.lesson.meta;

    const lesson = {
        isEvaluable,
        status: clesson.status,
        // TODO: нам в clesson не приходит evaluation date, вынуждены! брать из меты. Может порождать баги
        evaluationDate: new Date(get(clesson, 'lesson.meta.evaluation_date', null)),
        stream: clesson.stream,
    };

    const isInExternalHomework = Boolean(clesson?.external_homework?.homework_id);

    const lessonPermissions = getLessonPermissions({
        lesson,
        lessonMeta,
        course,
        hasLesson: true,
        isInExternalHomework,
        now,
    });

    const clessonId = clesson.id;

    const isParent = getIsParent(storeState);
    const shouldDisableClesson = checkShouldDisableLesson ? checkShouldDisableLesson(clessonId) : false;

    return {
        clessonId: lessonSelectors.getCLessonId(storeState),
        isContentManager: getIsContentManager(storeState),
        isParent,
        isTeacher: getIsTeacher(storeState),
        shouldDisableClesson,
        clessonProgress,
        clessonProgressLoadingStatus,
        course,
        lessonPermissions,
        // подписки загружаются только по клику на три точки
        activeSubscriptionSlug: isParent ? null : getActiveSubscriptionSlug(storeState, { courseId, subscriptions }),
        isInStudentLinkExperiment: getIsStudentRegistrationLinkAvailableInTeam(storeState, { classId }),
        currentTeamEnteringCode: getCurrentTeamEnteringCode(storeState, { classId }),
        forceCompleteLessonSuccess,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            clearEditor: lessonActions.clearEditor,
            deleteCLesson: lessonActions.deleteCLesson,
            getClessonWithResultsRequest: lessonActions.getClessonWithResultsRequest,
            getFullClessonRequest: lessonActions.getFullClessonRequest,
            showIntlMessageNotification: showIntlMessageNotificationAction,
            copyLesson: copyLessonModalActions.copyCLesson,
            forceCompleteLesson: actions.forceCompleteLesson,
            showLessonDeletedToast: lessonActions.showLessonDeletedToast,
            clearPrepLessonsDetails: prepLessonsActions.clearPrepLessonsDetails,
        },
        dispatch
    );
};

export default withRouterPath(
    withTime(injectIntl(withSocketIO(connect(mapStateToProps, mapDispatchToProps)(LessonItemView))))
);
